import { jwtDecode } from 'jwt-decode';

export const setTokens = (accessToken, refreshToken = null) => {
  localStorage.setItem('access_token', accessToken);
  refreshToken && localStorage.setItem('refresh_token', refreshToken);
};

export const getToken = () => localStorage.getItem('access_token');

export const removeTokens = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
};

export const isTokenExpired = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp * 1000;
  } catch {
    return true;
  }
};